const defaultState = {
  active: null
}

export default (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_ACTIVE_ENDPOINT':
      return Object.assign({}, state, { active: action.endpoint })
    default:
      return state
  }
}
